import {



    createRouter,
    createWebHistory
} from "vue-router";

import FpmRoutes from "../../Modules/FacturaPorMail/Resources/assets/js/fpm-routes.js";
import FacturasWebRoutes from "../../Modules/FacturasWeb/Resources/assets/js/facurasweb-routes.js";

const routes = [...FpmRoutes, ...FacturasWebRoutes];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
